module.exports = __webpack_public_path__ + "img/Mask Group 2880@2x.6da85345.png";